/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { Injectable } from '@angular/core';

/**
 * Provides the CognitoApiConfiguration configuration object with a given root URL.
 */
export function provideCognitoApiConfiguration(rootUrl: string) {
  var config = new CognitoApiConfiguration();
  config.rootUrl = rootUrl;
  return {
    provide: CognitoApiConfiguration,
    useValue: config
  };
}

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class CognitoApiConfiguration {
  rootUrl: string = '';
}

/**
 * Parameters for `O2CognitoApiModule.forRoot()`
 */
export interface CognitoApiConfigurationParams {
  rootUrl?: string;
}
